<div class="ribbon-wrapper" [ngClass]="colorClass"><div [ngClass]="colorClass" class="ribbon" [innerHTML]="text"></div></div>
